module.exports = __webpack_public_path__ + "simquadrat-top.svg?08c96b3cf775799096c86c1ad7bfd19e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/simquadrat-top.svg
// module id = 68
// module chunks = 0